import * as React from 'react';
import { Circle as CircleContent, CircleBadge, CircleBadgeText, CircleContainer } from "./styles";


export const Circle = ({
  icon,
  borderColor,
  color,
  hasBadge,
  badgeColor,
  badgeBorderColor,
  badgeIcon,
  badgeText,
  badgeTextColor,
  isTransparent,
  testId = 'default' }) => /*#__PURE__*/

React.createElement(CircleContainer, { isTransparent: isTransparent }, /*#__PURE__*/
React.createElement(CircleContent, {

  borderColor: borderColor,
  backgroundColor: color },

icon),


hasBadge && /*#__PURE__*/
React.createElement(CircleBadge, {

  borderColor: badgeBorderColor,
  backgroundColor: badgeColor },

badgeIcon && badgeIcon,
badgeText && /*#__PURE__*/
React.createElement(CircleBadgeText, {

  color: badgeTextColor },

badgeText)));